import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faBars, faTimes, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import './header.css';

import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from '../login_func/login_button';
import Logout_but from '../login_func/logout_button';

const insta_headr_link = 'https://www.instagram.com/sharadsnaik/';
const lnkdIn_hedr_link = 'https://www.linkedin.com/in/sharad-naik-b3238b239/';
const mail_headr_link = 'https://mail.google.com/mail/u/0/#inbox?compose=new';

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const { isAuthenticated } = useAuth0();

  const toggleMenu = () => setMenuOpened(!menuOpened);
  const closeMenu = () => setMenuOpened(false);

  const openLink = (link) => {
    window.location.href = link;
  };

  return (
    <div className='header-wrapper'>
      <div className={`header-pill ${menuOpened ? 'menu-active' : ''}`}>
        
        <div className="header-logo" onClick={closeMenu}>
          <h2>SHARAD NAIK</h2>
        </div>

        {/* Desktop Navigation */}
        <ul className='desktop-nav'>
          <li><RouterLink to='/home' className="nav-link" onClick={closeMenu}>Home</RouterLink></li>
          <li><Link to='contact' spy={true} smooth={true} offset={-50} onClick={closeMenu} className="nav-link">Contact</Link></li>
          <li><RouterLink to='/Personal' className="nav-link" onClick={closeMenu}>Personal</RouterLink></li>
          <li><Link to='education' spy={true} smooth={true} offset={-50} onClick={closeMenu} className="nav-link">Education</Link></li>
          <li><Link to='startup' spy={true} smooth={true} offset={-80} onClick={closeMenu} className="nav-link">Blogs</Link></li>
        </ul>

        {/* Desktop Actions */}
        <div className='desktop-actions'>
          <div className="social-pill">
            <FontAwesomeIcon className='social-icon' icon={faLinkedin} onClick={() => openLink(lnkdIn_hedr_link)} />
            <FontAwesomeIcon className='social-icon' icon={faEnvelope} onClick={() => openLink(mail_headr_link)} />
            <FontAwesomeIcon className='social-icon' icon={faInstagram} onClick={() => openLink(insta_headr_link)} />
          </div>
          <div className="auth-pill">
            {isAuthenticated ? <Logout_but /> : <LoginButton />}
          </div>
        </div>

        {/* Mobile Hamburger Button */}
        <div className={`mobile-hamburger ${menuOpened ? 'active' : ''}`} onClick={toggleMenu}>
          <FontAwesomeIcon icon={menuOpened ? faTimes : faBars} size="lg" />
        </div>

        {/* Mobile Navigation Dropdown */}
        <div className={`mobile-dropdown ${menuOpened ? 'open' : ''}`}>
          <ul className='mobile-nav-links'>
            <li><RouterLink to='/home' className="nav-link" onClick={closeMenu}>Home</RouterLink></li>
            <li><Link to='contact' spy={true} smooth={true} offset={-50} onClick={closeMenu} className="nav-link">Contact</Link></li>
            <li><RouterLink to='/Personal' className="nav-link" onClick={closeMenu}>Personal</RouterLink></li>
            <li><Link to='education' spy={true} smooth={true} offset={-50} onClick={closeMenu} className="nav-link">Education</Link></li>
            <li><Link to='startup' spy={true} smooth={true} offset={-80} onClick={closeMenu} className="nav-link">Blogs</Link></li>
            <li className="mobile-auth-btn">{isAuthenticated ? <Logout_but /> : <LoginButton />}</li>
          </ul>
          <div className='mobile-social'>
            <FontAwesomeIcon className='social-icon' icon={faLinkedin} onClick={() => openLink(lnkdIn_hedr_link)} />
            <FontAwesomeIcon className='social-icon' icon={faEnvelope} onClick={() => openLink(mail_headr_link)} />
            <FontAwesomeIcon className='social-icon' icon={faInstagram} onClick={() => openLink(insta_headr_link)} />
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Header;
